import { Project } from '../types';

const project: Project = {
  slug: 'casa-terracota',
  accessPin: '6632',
  qrTickets: ['C6T3B8'],
  info: {
    id: 6,
    title: 'Casa Terracota',
    category: {
      'en-US': 'Residential',
      'es-MX': 'Residencial',
    },
    year: 2024,
    location: 'Pueblo Nuevo, La Paz, B.C.S.',
    floor: '1 floors',
    building: '180aZA-',
    cover: '/images/Cover6.webp',
    description: {
      'en-US':
        'This residential project blends traditional architectural elements with contemporary design principles. The clean white facades, red pitched roof tiles, and warm-toned stone base create a balanced and elegant aesthetic. The arched entrance and window frames highlight classic influences, while large glass doors and open patio spaces enhance natural light and connectivity. Landscaping with native vegetation and pavers further anchors the home in its environment, offering both functionality and timeless curb appeal.',
      'es-MX':
        'Este proyecto residencial combina elementos arquitectonicos tradicionales con principios de diseno contemporaneo. Las fachadas blancas, las tejas rojas y la base de piedra en tonos calidos crean una estetica equilibrada y elegante. El acceso en arco y los marcos de ventana resaltan influencias clasicas, mientras grandes puertas de vidrio y patios abiertos favorecen la luz natural y la conexion interior-exterior. La vegetacion nativa y los adoquines anclan la vivienda al entorno con funcionalidad y atemporalidad.',
    },
  },
  assets: {
    images: [
      { file: '6.1', ext: 'webp' },
      { file: '6.2', ext: 'webp' },
      { file: '6.3', ext: 'webp' },
      { file: '6.4', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
